<template>
    <div class="app">
        <div class="list_box">
            <div class="list_cent">
                <img src="../../assets/image/img/列表页/h_banner.jpg">
                <div class="list_centbox">
                    <div class="list_centboxlet">
                        <div class="list_centboxletA">
                            <h4>精品分类<span>LUXURY</span></h4>
                            <div class="list_centboxletA_list">
                                <div class="list_centboxletA_listA">
                                    <div class="list_centboxletAs">
                                        <div class="list_centboxletA_listAimgA"></div>
                                        <p>今日热销</p>
                                    </div>
                                    <div class="list_centboxletA_listAimgB"></div>
                                </div>
                                <div class="list_centboxletA_listA">
                                    <div class="list_centboxletAs">
                                        <div class="list_centboxletA_listAimgC"></div>
                                        <p>时令蔬菜</p>
                                    </div>
                                    <div class="list_centboxletA_listAimgB"></div>
                                </div>
                                <div class="list_centboxletA_listA">
                                    <div class="list_centboxletAs">
                                        <div class="list_centboxletA_listAimgD"></div>
                                        <p>肉类</p>
                                    </div>
                                    <div class="list_centboxletA_listAimgB"></div>
                                </div>
                                <div class="list_centboxletA_listA">
                                    <div class="list_centboxletAs">
                                        <div class="list_centboxletA_listAimgE"></div>
                                        <p>新鲜水果</p>
                                    </div>
                                    <div class="list_centboxletA_listAimgB"></div>
                                </div>
                                <div class="list_centboxletA_listA">
                                    <div class="list_centboxletAs">
                                        <div class="list_centboxletA_listAimgF"></div>
                                        <p>干菜调料</p>
                                    </div>
                                    <div class="list_centboxletA_listAimgB"></div>
                                </div>
                                <div class="list_centboxletA_listA">
                                    <div class="list_centboxletAs">
                                        <div class="list_centboxletA_listAimgG"></div>
                                        <p>粮油</p>
                                    </div>
                                    <div class="list_centboxletA_listAimgB"></div>
                                </div>
                            </div>
                        </div>
                        <div class="list_centboxletB">
                            <div class="deta_maincentAb">
                                <h4>热销榜<span>CHANNEL</span></h4>
                                <div class="deta_maincentAbs">
                                    <div class="deta_maincentAbst">
                                        <div
                                            class="deta_maincentAbstA"
                                            v-for="(item,index) in cakes"
                                            :key="index"
                                        >
                                            <img :src="item.images">
                                            <div class="deta_maincentAbstAs">
                                                <p>{{item.name}}</p>
                                                <p>￥{{item.price}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="list_centboxrig">
                        <div class="list_centboxrigA">
                            <div class="list_centboxrigAcent">
                                <h4>商品列表</h4>
                                <div class="list_centboxrigAa">
                                    <div class="list_centboxrigAas">
                                        <h3>精品蔬菜：</h3>
                                        <ul
                                            v-for="(item,index) in listgoods"
                                            :key="index"
                                        >
                                            <li
                                                :class="{active:adds==index}"
                                                @click="addst(index)"
                                            >
                                                <p>{{item.names}}</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <h2>豆类<span>商品筛选</span></h2>
                                </div>
                                <div class="list_centboxrigAbtn">
                                    <div class="list_centboxrigAbtnA">
                                        <h3>种类：</h3>
                                        <ul
                                            v-for="(item,index) in species"
                                            :key="index"
                                        >
                                            <li
                                                :class="{active:addsts==index}"
                                                @click="speciess(index)"
                                            >
                                                <p>{{item.names}}</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="list_centboxrigAbtnA">
                                        <h3>详细分类：</h3>
                                        <ul
                                            v-for="(item,index) in classification"
                                            :key="index"
                                        >
                                            <li
                                                :class="{active:addsm==index}"
                                                @click="classifications(index)"
                                            >
                                                <p>{{item.names}}</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="list_centboxrigB">
                            <div class="list_centboxrigBcent">
                                <div class="list_centboxrigBcents">
                                    <h3>排序：</h3>
                                    <ul
                                        v-for="(item,index) in sorting"
                                        :key="index"
                                    >
                                        <li
                                            :class="{active:sortings==index}"
                                            @click="sortingst(index)"
                                        >
                                            <p>{{item.names}}</p>
                                        </li>
                                    </ul>
                                </div>
                                <p>共<span>20</span>商品</p>
                            </div>
                        </div>
                        <div class="list_centboxriglist">
                            <div class="list_centboxriglists">
                                <div
                                    class="list_centboxriglistA"
                                    v-for="(item,index) in listdetailed"
                                    :key="index"
                                    @click="detalis"
                                >
                                    <img :src="item.images">
                                    <h5>{{item.names}}</h5>
                                    <p>抢购价:<span>{{item.money}}元/斤</span></p>
                                    <h4>原价:{{item.price}}元</h4>
                                    <div class="list_centboxriglistAs">
                                        <div class="list_centboxriglistAsa">
                                            <div class="list_centboxriglistAsimgs"></div>
                                            加入购物车
                                        </div>
                                        <div class="list_centboxriglistAsb">
                                            收藏
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="block">
                                <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="currentPage4"
                                    :page-sizes="[100, 200, 300, 400]"
                                    :page-size="100"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="400"
                                >
                                </el-pagination>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="listboxbtom"></div>
        <el-backtop :bottom="100">
            <div style="{
		        height: 100%;
		        width: 100%;
		        border-radius: 100px;
		        background-color: #f2f5f6;
		        box-shadow: 0 0 6px rgba(0,0,0, .12);
		        text-align: center;
		        line-height: 40px;
		        color: #569516;
		      }">
                <i class="el-icon-upload2"></i>
            </div>
        </el-backtop>
    </div>
</template>

<script>
    // 引入放大镜组件
    import Magnifier from '../../components/magnifier.vue';
    export default
    {
        components:
        {
            Magnifier
        },
        data()
        {
            return {
                //分页
                currentPage4: 1,
                adds: 0,
                addsts: 0,
                addsm: 0,
                sortings: 0,
                cakes: [
                {
                    images: require( '../../assets/image/img/列表页/title-rx_1.jpg' ),
                    name: "丝瓜",
                    price: 1.00
                },
                {
                    images: require( '../../assets/image/img/列表页/title-rx_2.jpg' ),
                    name: "苦瓜",
                    price: 1.00
                },
                {
                    images: require( '../../assets/image/img/列表页/title-rx_3.jpg' ),
                    name: "大白菜",
                    price: 1.00
                },
                {
                    images: require( '../../assets/image/img/列表页/title-rx_4.jpg' ),
                    name: "小黄鱼",
                    price: 1.00
                },
                {
                    images: require( '../../assets/image/img/列表页/title-rx_5.jpg' ),
                    name: "五花肉",
                    price: 1.00
                } ],
                listgoods: [
                {
                    names: "柑果类"
                },
                {
                    names: "瓜果类"
                },
                {
                    names: "核果类"
                },
                {
                    names: "坚果类"
                },
                {
                    names: "浆果类"
                },
                {
                    names: "仁果类"
                },
                {
                    names: "热带水果"
                } ],
                species: [
                {
                    names: "不限"
                },
                {
                    names: "瓜类"
                },
                {
                    names: "叶菜类"
                },
                {
                    names: "茄果类"
                },
                {
                    names: "葱蒜类"
                },
                {
                    names: "甘蓝类"
                },
                {
                    names: "薯芋类"
                },
                {
                    names: "水生类"
                },
                {
                    names: "豆类菌"
                },
                {
                    names: "菇类"
                },
                {
                    names: "根茎类"
                } ],
                classification: [
                {
                    names: "板栗"
                },
                {
                    names: "核桃"
                },
                {
                    names: "松子"
                },
                {
                    names: "腰果"
                },
                {
                    names: "开心果"
                },
                {
                    names: "巴旦"
                },
                {
                    names: "木杏"
                },
                {
                    names: "仁白"
                },
                {
                    names: "果榛子"
                } ],
                sorting: [
                {
                    names: "更新时间"
                },
                {
                    names: "销量"
                },
                {
                    names: "价格"
                },
                {
                    names: "上架时间"
                } ],
                listdetailed: [
                {
                    images: require( '../../assets/image/img/列表页/Inside-sp_1.jpg' ),
                    money: "6.5",
                    names: "蔬菜",
                    price: "7.0"
                },
                {
                    images: require( '../../assets/image/img/列表页/Inside-sp_2.jpg' ),
                    money: "6.5",
                    names: "蔬菜",
                    price: "7.0"
                },
                {
                    images: require( '../../assets/image/img/列表页/Inside-sp_3.jpg' ),
                    money: "6.5",
                    names: "蔬菜",
                    price: "7.0"
                },
                {
                    images: require( '../../assets/image/img/列表页/Inside-sp_4.jpg' ),
                    money: "6.5",
                    names: "蔬菜",
                    price: "7.0"
                },
                {
                    images: require( '../../assets/image/img/列表页/Inside-sp_5.jpg' ),
                    money: "6.5",
                    names: "蔬菜",
                    price: "7.0"
                },
                {
                    images: require( '../../assets/image/img/列表页/Inside-sp_6.jpg' ),
                    money: "6.5",
                    names: "蔬菜",
                    price: "7.0"
                },
                {
                    images: require( '../../assets/image/img/列表页/Inside-sp_7.jpg' ),
                    money: "6.5",
                    names: "蔬菜",
                    price: "7.0"
                },
                {
                    images: require( '../../assets/image/img/列表页/Inside-sp_8.jpg' ),
                    money: "6.5",
                    names: "蔬菜",
                    price: "7.0"
                },
                {
                    images: require( '../../assets/image/img/列表页/Inside-sp_9.jpg' ),
                    money: "6.5",
                    names: "蔬菜",
                    price: "7.0"
                },
                {
                    images: require( '../../assets/image/img/列表页/Inside-sp_10.jpg' ),
                    money: "6.5",
                    names: "蔬菜",
                    price: "7.0"
                },
                {
                    images: require( '../../assets/image/img/列表页/Inside-sp_11.jpg' ),
                    money: "6.5",
                    names: "蔬菜",
                    price: "7.0"
                },
                {
                    images: require( '../../assets/image/img/列表页/Inside-sp_12.jpg' ),
                    money: "6.5",
                    names: "蔬菜",
                    price: "7.0"
                },
                {
                    images: require( '../../assets/image/img/列表页/Inside-sp_13.jpg' ),
                    money: "6.5",
                    names: "蔬菜",
                    price: "7.0"
                },
                {
                    images: require( '../../assets/image/img/列表页/Inside-sp_14.jpg' ),
                    money: "6.5",
                    names: "蔬菜",
                    price: "7.0"
                },
                {
                    images: require( '../../assets/image/img/列表页/Inside-sp_15.jpg' ),
                    money: "6.5",
                    names: "蔬菜",
                    price: "7.0"
                },
                {
                    images: require( '../../assets/image/img/列表页/Inside-sp_16.jpg' ),
                    money: "6.5",
                    names: "蔬菜",
                    price: "7.0"
                } ]
            }
        },
        methods:
        {
            addst( index )
            {
                this.adds = index
            },
            speciess( index )
            {
                this.addsts = index
            },
            classifications( index )
            {
                this.addsm = index
            },
            sortingst( index )
            {
                this.sortings = index
            },
            detalis()
            {
                this.$router.push(
                {
                    path: '/details'
                } )
            },
            //分页器
            handleSizeChange( val )
            {
                console.log( `每页 ${val} 条` );
            },
            handleCurrentChange( val )
            {
                console.log( `当前页: ${val}` );
            }
        },

    }
</script>

<style scoped="scoped">
    .list_box {
        width: 100%;
        height: 100%;
        background-color: #F1F1F1;
        display: flex;
        justify-content: center;
    }

    .listboxbtom {
        width: 100%;
        height: 5rem;
        background-color: #F1F1F1;
    }

    .list_cent {
        width: 75rem;
        height: 100%;
        margin-top: 1.875rem;
    }

    .list_centbox {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-around;
        margin-top: 1.875rem;
    }

    .list_centboxlet {
        width: 16.8125rem;
        height: 100%;
    }

    .list_centboxletA {
        width: 100%;
        height: 27.5rem;
        background: #FFFFFF;
    }

    .list_centboxletA h4 {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        line-height: 34px;
        padding: 1rem;
    }

    .list_centboxletA span {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #999999;
        line-height: 34px;
        margin-left: 1rem;
    }

    .list_centboxletA_list {
        width: 100%;
    }

    .list_centboxletA_listA {
        width: 100%;
        height: 3.0625rem;
        border-bottom: 1px solid #E7E7E7;
        display: flex;
        justify-content: space-between;
    }

    .list_centboxletA_listA:hover {
        background-color: #d9d9d9;
        cursor: pointer;
    }

    .list_centboxletAs {
        display: flex;
        padding-top: 0.8rem;
    }

    .list_centboxletAs p {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        opacity: 0.8;
        margin-left: 1rem;
    }

    .list_centboxletA_listAimgA {
        background: url('../../assets/image/iocn/iocnfont.png') no-repeat -186px -92px;
        width: 17px;
        height: 19px;
        margin-left: 1rem;
    }

    .list_centboxletA_listAimgB {
        background: url('../../assets/image/iocn/iocnfont.png') no-repeat -348px -97px;
        width: 8px;
        height: 13px;
        margin: 1rem;
    }

    .list_centboxletA_listAimgC {
        background: url('../../assets/image/iocn/iocnfont.png') no-repeat -212px -91px;
        width: 17px;
        height: 20px;
        margin-left: 1rem;
    }

    .list_centboxletA_listAimgD {
        background: url('../../assets/image/iocn/iocnfont.png') no-repeat -236px -95px;
        width: 22px;
        height: 14px;
        margin-left: 1rem;
    }

    .list_centboxletA_listAimgE {
        background: url('../../assets/image/iocn/iocnfont.png') no-repeat -263px -92px;
        width: 19px;
        height: 19px;
        margin-left: 1rem;
    }

    .list_centboxletA_listAimgF {
        background: url('../../assets/image/iocn/iocnfont.png') no-repeat -291px -94px;
        width: 18px;
        height: 16px;
        margin-left: 1rem;
    }

    .list_centboxletA_listAimgG {
        background: url('../../assets/image/iocn/iocnfont.png') no-repeat -318px -91px;
        width: 14px;
        height: 22px;
        margin-left: 1rem;
    }

    .list_centboxletB {
        width: 100%;
        height: 39.125rem;
        background: #FFFFFF;
        margin-top: 1rem;
    }

    .deta_maincentAb {
        width: 16.8125rem;
        height: 39.125rem;
        background: #FFFFFF;
        margin-top: 2rem;

    }

    .deta_maincentAb h4 {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        line-height: 34px;
        padding: 1.5rem;
    }

    .deta_maincentAb span {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #999999;
        line-height: 34px;
        margin-left: 1rem;
    }

    .deta_maincentAbs {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .deta_maincentAbst {
        width: 14.3125rem;
        height: 100%;

    }

    .deta_maincentAbstA {
        display: flex;
        width: 14.3125rem;
        border-bottom: 1px solid #E2E2E2;
        margin-top: 1rem;
    }

    .deta_maincentAbstA img {
        width: 7.3125rem;
        height: 4.75rem;
    }

    .deta_maincentAbstAs {}

    .deta_maincentAbstAs p {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
        margin: 0.2rem 0.5rem;
    }

    .deta_maincentAbstAs p:nth-child(2) {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ED0000;
    }


    .list_centboxrig {
        width: 56.5625rem;
        height: 100%;
    }

    .list_centboxrigA {
        width: 100%;
        height: 317px;
        background: #FFFFFF;
        display: flex;
        justify-content: center;
    }

    .list_centboxrigAcent {
        width: 53.125rem;
        height: 100%;
        margin-top: 1rem;
    }

    .list_centboxrigA h4 {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #069338;
        line-height: 34px;
    }

    .list_centboxrigAa {
        border-bottom: 2px dashed #CFCFCF;
        border-top: 2px dashed #CFCFCF;
        height: 7.8125rem;
    }

    .list_centboxrigAa h2 {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #069338;
        line-height: 34px;
        margin-top: 1.5rem;
    }

    .list_centboxrigAa span {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 34px;
        margin-left: 1rem;
    }

    .list_centboxrigAas {
        display: flex;
        margin-top: 1.5rem;
    }

    .list_centboxrigAa h3 {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 34px;

    }

    .list_centboxrigAa ul {
        margin-top: 0.5rem;
    }

    .list_centboxrigAa li {
        width: 3.875rem;
        height: 1.375rem;
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        text-align: center;
        cursor: pointer;
        line-height: 20px;
    }

    .active {
        width: 3.875rem;
        height: 1.375rem;
        background: #069338;
        border-radius: 11px;

    }

    .active p {
        color: #FFFFFF;
    }

    .list_centboxrigAbtn {}

    .list_centboxrigAbtn h3 {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 34px;
    }

    .list_centboxrigAbtn ul {
        margin-top: 0.5rem;
    }

    .list_centboxrigAbtn li {
        width: 3.875rem;
        height: 1.375rem;
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        text-align: center;
        cursor: pointer;
        line-height: 20px;
    }

    .list_centboxrigAbtnA {
        display: flex;
        margin-top: 1.5rem;
    }


    .list_centboxrigB {
        width: 100%;
        height: 72px;
        background: #FFFFFF;
        margin-top: 1.25rem;
        display: flex;
        justify-content: center;
    }

    .list_centboxrigBcent {
        width: 53.125rem;
        height: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 1.5rem;
    }

    .list_centboxrigBcent p:nth-child(2) {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 34px;
    }

    .list_centboxrigBcent span {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 34px;
    }

    .list_centboxrigBcents {
        display: flex;
    }

    .list_centboxrigBcent li {
        width: 3.875rem;
        height: 1.375rem;
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        text-align: center;
        cursor: pointer;
        line-height: 20px;
    }

    .list_centboxrigBcent h3 {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }

    .list_centboxriglist {
        width: 100%;
        height: 85.625rem;
        margin-top: 1.25rem;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .list_centboxriglists {
        width: 100%;
        height: 81rem;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .list_centboxriglistA {
        width: 13.6875rem;
        height: 19.6875rem;
        background: #FFFFFF;
        text-align: center;
        transition-duration: 0.4s;
    }

    .list_centboxriglistA:hover {
        -webkit-box-shadow: #ccc 200px 20px 20px;
        -moz-box-shadow: #ccc 10px 10px 10px;
        box-shadow: #ccc 10px 10px 10px;
        -webkit-transform: translate(0px, -5px);
        -moz-transform: translate(5px, 5px);
        background-color: #FFFFFF;
        cursor: pointer;
    }

    .list_centboxriglistAs {
        display: flex;
        margin: 1rem 1.4rem;
        width: 100%;
    }

    .list_centboxriglistAsa {
        width: 6.0625rem;
        height: 1.5625rem;
        background: #F16E1F;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 25px;
        padding-left: 0.5rem;
        cursor: pointer;
    }

    .list_centboxriglistA h5 {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 34px;
    }

    .list_centboxriglistA h4 {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        text-decoration: line-through;
        color: #999999;
    }

    .list_centboxriglistA p {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
    }

    .list_centboxriglistA span {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 600;
        color: #ED0000;
    }

    .list_centboxriglistAsimgs {
        background: url('../../assets/image/iocn/iocnfont.png') no-repeat -42px -3px;
        width: 14px;
        height: 15px;
        position: absolute;
        margin: 0.3rem 0rem;
    }

    .list_centboxriglistAsb {
        width: 4rem;
        height: 1.5625rem;
        background: #B2B2B2;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 25px;
        margin-left: 1rem;
        cursor: pointer;
    }

    .block {
        margin-left: 12rem;
    }

    .el-pager li.active {
        color: #069338;
    }
</style>
<style>
    .el-pager li.active {
        color: #069338;
    }

    .el-pager li:hover {
        color: #069338;
    }

    .el-select .el-input.is-focus .el-input__inner {
        border-color: #069338;
    }

    .el-select .el-input.is-focus .el-input__inner {
        border-color: #069338;
    }

    .el-select .el-input__inner:focus {
        border-color: #069338;
    }

    .el-select .el-input__inner:focus {
        border-color: #069338;
    }

    .el-select .el-input.is-focus .el-input__inner {
        border-color: #069338;
    }

    .el-pagination__sizes .el-input .el-input__inner:hover {
        border-color: #069338;
    }

    .el-select-dropdown__item.selected {
        color: #069338;
        font-weight: 700;
    }
</style>